"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import "./wdyr";
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var react_redux_1 = require("react-redux");
var auth0_react_1 = require("@auth0/auth0-react");
var react_router_dom_1 = require("react-router-dom");
var config_1 = require("./config");
var store_1 = require("./store");
var App_1 = __importDefault(require("./components/App"));
document.addEventListener("DOMContentLoaded", function () {
    var root = (0, client_1.createRoot)(document.getElementById("root"));
    root.render(react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
        react_1.default.createElement(auth0_react_1.Auth0Provider, { domain: config_1.AUTH_DOMAIN, clientId: config_1.AUTH_CLIENT_ID, redirectUri: window.location.origin, audience: config_1.AUTH_AUDIENCE, scope: "read:content manage:content" },
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(App_1.default, null)))));
});
